<template>
  <v-flex xs12 class="pt-4">
    <div class="title mb-1 d-flex align-center">
      <span style="width: 100%; min-height: 34px" class="d-flex align-center">
        {{ title }}
        <v-tooltip bottom v-if="tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="tooltip"
              small
              class="ml-2 grey--text"
              v-bind="attrs"
              v-on="on"
              style="max-width: min-content"
            >
              help
            </v-icon>
          </template>
          <span v-html="tooltip"> </span>
        </v-tooltip>
      </span>
      <v-btn
        v-if="!hideButton"
        color="primary"
        small
        :disabled="loading"
        @click="$emit('btn-click')"
        flat
      >
        <v-icon left dark class="mr-1">mdi-{{ buttonIcon }}</v-icon>

        {{ buttonText }}
      </v-btn>
    </div>
    <v-divider class="mb-1" />
    <v-flex xs12>
      <slot></slot>
    </v-flex>
  </v-flex>
</template>

<script>
export default {
  name: "edit-topic",
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    buttonIcon: {
      type: String,
      default: "code-braces",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss"></style>
